<template>
  <span>
    <template v-if="collection">
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M6 15V5" stroke="#999999" stroke-width="1.2" />
            <path
              d="M6 5H14L12.8571 7.69231L14 10.3846H6V5Z"
              stroke="#999999"
              stroke-width="1.2"
              stroke-linejoin="round"
            />
          </svg>
        </template>
        <template v-else>
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M6 15V5" stroke="#FF7D00" stroke-width="1.2" />
            <path
              d="M6 5H14L12.8571 7.5L14 10H6V5Z"
              fill="#FF7D00"
              stroke="#FF7D00"
              stroke-width="1.2"
              stroke-linejoin="round"
            />
          </svg>
        </template>
  </span>
</template>
<script>

export default {
  props:{
    collection: {
      type: Boolean,
      default:true
    }
  }
}
</script>

